export default "__VITE_ASSET__C28Fq4EX__"